"use client";

import { useState } from 'react';

export default function JobShare({ job, slug }) {
  const [copyTooltip, setCopyTooltip] = useState("Copy Link");
  
  const shareOnX = () => {
    const url = `https://x.com/intent/tweet?text=${encodeURIComponent(`Fully remote work from anywhere job: \n\n${job.title} at ${job.company}`)}&url=${encodeURIComponent(`https://www.realworkfromanywhere.com/jobs/${slug}`)}&via=realwfa`;
    window.open(url, '_blank', 'width=550,height=420');
  };
  
  const shareOnLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`https://www.realworkfromanywhere.com/jobs/${slug}`)}`;
    window.open(url, '_blank', 'width=550,height=420');
  };
  
  const shareViaEmail = () => {
    const subject = encodeURIComponent(`Remote Job: ${job.title} at ${job.company}`);
    const body = encodeURIComponent(`Check out this remote job I found:\n\n${job.title} at ${job.company}\n\nhttps://www.realworkfromanywhere.com/jobs/${slug}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };
  
  const copyLink = () => {
    const jobUrl = `https://www.realworkfromanywhere.com/jobs/${slug}`;
    navigator.clipboard.writeText(jobUrl).then(() => {
      setCopyTooltip("Link Copied!");
      setTimeout(() => {
        setCopyTooltip("Copy Link");
      }, 2000);
    });
  };
  
  return (
    <div className="flex gap-3">
      {/* X (Twitter) Share */}
      <div className="tooltip tooltip-bottom" data-tip="Share on X">
        <button 
          onClick={shareOnX}
          className="btn btn-circle btn-sm bg-[#444] text-white hover:bg-[#555] border-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
          </svg>
        </button>
      </div>
      
      {/* LinkedIn Share */}
      <div className="tooltip tooltip-bottom" data-tip="Share on LinkedIn">
        <button 
          onClick={shareOnLinkedIn}
          className="btn btn-circle btn-sm bg-[#444] text-white hover:bg-[#555] border-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.47,2H3.53A1.45,1.45,0,0,0,2,3.39V20.61A1.45,1.45,0,0,0,3.53,22H20.47a1.45,1.45,0,0,0,1.53-1.39V3.39A1.45,1.45,0,0,0,20.47,2ZM8.09,18.74H5.25V9.31H8.09ZM6.67,8.07A1.71,1.71,0,1,1,8.33,6.33,1.71,1.71,0,0,1,6.67,8.07ZM18.74,18.74H15.91V14.47c0-1.06,0-2.41-1.46-2.41s-1.69,1.15-1.69,2.33v4.35H9.93V9.31h2.7v1.24h0a3,3,0,0,1,2.67-1.46c2.86,0,3.39,1.88,3.39,4.32Z"/>
          </svg>
        </button>
      </div>
      
      {/* Email Share */}
      <div className="tooltip tooltip-bottom" data-tip="Share via Email">
        <button 
          onClick={shareViaEmail}
          className="btn btn-circle btn-sm bg-[#444] text-white hover:bg-[#555] border-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"/>
          </svg>
        </button>
      </div>
      
      {/* Copy Link */}
      <div className="tooltip tooltip-bottom" data-tip={copyTooltip}>
        <button 
          onClick={copyLink}
          className="btn btn-circle btn-sm bg-[#444] text-white hover:bg-[#555] border-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}